module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flexContainer full"
  }, [_c('section', {
    attrs: {
      "id": "sectionPrincipal"
    }
  }, [_c('AdminTools'), _vm._v(" "), _c('section', {
    staticClass: "mobileNot"
  }, [_c('section', {
    staticClass: "searchResultsWrapper tabletNot"
  }, [_c('section', [(_vm.loading === true) ? _c('div', {
    staticClass: "abs flexContainer",
    attrs: {
      "id": "spinnerLoader"
    }
  }, [_c('Spinner', {
    staticClass: "loader",
    attrs: {
      "animation-duration": 2500,
      "size": 60,
      "color": '#41b4e8'
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs primary-text"
  }, [_vm._l((_vm.componentTypeList), function(n, key) {
    return _c('li', {
      key: key,
      staticClass: "liStyle",
      class: {
        liActive: n.name === _vm.type
      }
    }, [_c('a', {
      staticClass: "componentLink uppercase",
      class: {},
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.openType(n.name);
        }
      }
    }, [_vm._v(_vm._s(n.terms.name[_vm.$t("trad")]))])])
  }), _vm._v(" "), _c('li', {
    staticClass: "liStyle",
    class: {
      liActive: 'shades' === _vm.type
    }
  }, [_c('a', {
    staticClass: "componentLink uppercase txtCenter",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.openType('shades');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("planobuilder.shades")))])]), _vm._v(" "), _c('li', {
    staticClass: "liStyle",
    class: {
      liActive: 'plano' === _vm.type
    }
  }, [_c('a', {
    staticClass: "componentLink uppercase txtCenter",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.openType('plano');
      }
    }
  }, [_vm._v("plano")])])], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn fright uppercase reactive",
    on: {
      "click": function($event) {
        _vm.saveReactive();
      }
    }
  }, [_vm._v("Re-active")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "sectionPrincipal primary-text"
  }, _vm._l((_vm.inactiveComponents), function(m, index) {
    return (m.type === _vm.type && Object.keys(_vm.inactiveComponents).length > 0) ? _c('div', {
      key: index,
      staticClass: "accordeon"
    }, [_c('div', [_c('table', {
      staticClass: "tableComponent"
    }, [_c('tr', [_c('td', [(m.hasOwnProperty('figures') && m.figures.small === null) ? _c('img', {
      staticClass: "rel",
      attrs: {
        "src": require("../../../static/img/no_image.jpg"),
        "width": "100",
        "height": "100"
      }
    }) : _vm._e(), _vm._v(" "), (m.hasOwnProperty('figures') && m.figures.small !== null) ? _c('img', {
      staticClass: "rel",
      attrs: {
        "src": _vm.getImgPath(m.figures.small, 'medium'),
        "width": "100",
        "height": "100"
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "widthTD"
    }, [_c('p', {
      staticClass: "componentName uppercase"
    }, [_vm._v(_vm._s(m.terms.name[_vm.$t("trad")]["value"]))]), _vm._v(" "), (
      m.infosArticle.hasOwnProperty('diam_ref1') &&
      m.infosArticle.diam_ref1.componentProperty.value !== '-'
    ) ? _c('p', {
      staticClass: "componentName"
    }, [_vm._v("\n                                                " + _vm._s(m.infosArticle.diam_ref1.componentProperty.value) + "\n                                            ")]) : _vm._e(), _vm._v(" "), (
      (m.infosArticle.hasOwnProperty('diam_ref1') &&
        m.infosArticle.diam_ref1.componentProperty.value === '-') ||
      !m.infosArticle.hasOwnProperty('diam_ref1')
    ) ? _c('p', {
      staticClass: "componentName"
    }, [_vm._v("\n                                                No reference\n                                            ")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "widthDeleted"
    }, [_c('p', {
      staticClass: "componentName deletedBy"
    }, [_vm._v("\n                                                Deleted by: " + _vm._s(m.modifiedBy.firstname) + " " + _vm._s(m.modifiedBy.lastname) + " at " + _vm._s(m.modifiedDate) + "\n                                            ")])]), _vm._v(" "), _c('td', [_c('input', {
      staticClass: "check",
      attrs: {
        "type": "checkbox"
      },
      on: {
        "change": function($event) {
          _vm.reactivComponent(m.id, $event);
        }
      }
    })])])])]), _vm._v(" "), _c('br')]) : _vm._e()
  })), _vm._v(" "), _vm._l((_vm.inactiveShades), function(n, index) {
    return (_vm.type === 'shades') ? _c('div', {
      key: index,
      staticClass: "sectionPrincipal"
    }, [_c('table', {
      staticClass: "tableComponent"
    }, [_c('tr', [_c('td', [_c('div', {
      staticClass: "circle",
      style: ('background:' + n.properties.colors.color['value'])
    })]), _vm._v(" "), _c('td', {
      staticClass: "widthTD"
    }, [_c('p', {
      staticClass: "shadeName uppercase"
    }, [_vm._v(_vm._s(n.name))]), _vm._v(" "), (n.properties.hasOwnProperty('reference')) ? _c('p', {
      staticClass: "shadeName"
    }, [_vm._v("\n                                        " + _vm._s(n.properties.reference.client_ref1.value) + "\n                                    ")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "widthDeleted"
    }, [_c('p', {
      staticClass: "shadeName deletedBy"
    }, [_vm._v("Delete at: " + _vm._s(n.modifiedDate))])]), _vm._v(" "), _c('td', [_c('input', {
      staticClass: "check",
      attrs: {
        "type": "checkbox"
      },
      on: {
        "change": function($event) {
          _vm.reactivShades(n.id, $event);
        }
      }
    })])])]), _vm._v(" "), _c('br')]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.inactivePlano), function(n, index) {
    return (_vm.type === 'plano') ? _c('div', {
      key: index,
      staticClass: "sectionPrincipal"
    }, [_c('div', [_c('table', {
      staticClass: "tableComponentPlano"
    }, [_c('tr', [_vm._m(0, true), _vm._v(" "), _c('td', {
      staticClass: "widthTD"
    }, [_c('p', {
      staticClass: "componentName uppercase"
    }, [_vm._v(_vm._s(n.name))])]), _vm._v(" "), _c('td', {
      staticClass: "widthDeleted"
    }, [_c('p', {
      staticClass: "componentName"
    }, [_vm._v("\n                                            Deleted by: " + _vm._s(n.modifiedBy.firstname) + " " + _vm._s(n.modifiedBy.lastname) + " at " + _vm._s(n.modifiedDate) + "\n                                        ")])]), _vm._v(" "), _c('td', [_c('input', {
      staticClass: "check",
      attrs: {
        "type": "checkbox"
      },
      on: {
        "change": function($event) {
          _vm.reactivPlano(n.id, $event);
        }
      }
    })])])])]), _vm._v(" "), _c('br')]) : _vm._e()
  })], 2)])]), _vm._v(" "), _c('section', {
    staticClass: "mobileOnly mobile-warn"
  }, [_c('div', [_vm._v(_vm._s(_vm.$t("common.mobileNotDispo")))])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('img', {
    staticClass: "rel",
    attrs: {
      "src": require("../../../static/assets/plano.png"),
      "width": "50",
      "height": "80"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d881b90","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/InactiveComponent.vue
// module id = 3058
// module chunks = 0